import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog } from "@mui/material";
import BryxColors from "../types/theme";
import BryxBox from "./BryxBox";
import BryxButton from "./BryxButton";
import BryxIcon from "./BryxIcon/BryxIcon";
import BryxTypography from "./BryxTypography";
import { styled } from "@mui/system";
const BryxModalCloseButton = styled((props) => (_jsx(BryxIcon, { iconName: "close", mdIconSize: true, ...props })))(({ theme }) => ({
    color: BryxColors.specialColor(theme.palette.mode).greyButGray,
    height: "20px",
    width: "20px",
    marginRight: "2px",
    "&:hover": {
        color: BryxColors.brandPrimary(theme.palette.mode),
        cursor: "pointer",
        height: "24px",
        width: "24px",
        marginRight: "0 !important",
    },
}));
const BryxModal = (props) => {
    const { sx, ...dialogProps } = props;
    return (_jsx(Dialog, { ...dialogProps, PaperProps: { sx: { borderRadius: "8px", p: "64px", maxWidth: "unset", width: "80vw", ...sx } }, children: _jsxs(BryxBox, { isFlex: true, sx: { flexDirection: "column" }, children: [_jsx(BryxBox, { isFlex: true, centerAlignItems: true, sx: { justifyContent: "flex-end", gap: "16px", height: "24px" }, children: _jsx(BryxModalCloseButton, { onClick: () => props.onClose() }) }), _jsx(BryxBox, { isFlex: true, children: _jsx(BryxTypography, { sx: { mt: "16px", color: BryxColors.lightBrand(-2) }, variant: "h2", children: props.titleText }) }), _jsx(BryxBox, { isFlex: true, fullHeight: true, fullWidth: true, sx: { mt: "24px", mb: "48px" }, children: props.children }), _jsx(BryxBox, { isFlex: true, centerAlignItems: true, sx: { justifyContent: props.centerActions ? "center" : "flex-end", gap: "16px" }, children: props.actions
                        ?.filter(({ hidden }) => !hidden)
                        .map(({ title, fn, icon, buttonVariant, disabled }, idx) => (_jsx(BryxButton, { disabled: disabled, startIcon: icon, variant: buttonVariant ?? "outlined", onClick: () => fn(), children: title }, `action-${idx}`))) })] }) }));
};
export default BryxModal;
